export const ADD_OR_EDIT_CHAPTER = 'ADD_OR_EDIT_CHAPTER';
export const ADD_OR_EDIT_CHAPTER_SUCCESS = 'ADD_OR_EDIT_CHAPTER_SUCCESS';
export const ADD_OR_EDIT_CHAPTER_FAIL = 'ADD_OR_EDIT_CHAPTER_FAIL';
export const ADD_OR_EDIT_MANUAL = 'ADD_OR_EDIT_MANUAL';
export const ADD_OR_EDIT_MANUAL_SUCCESS = 'ADD_OR_EDIT_MANUAL_SUCCESS';
export const ADD_OR_EDIT_MANUAL_FAIL = 'ADD_OR_EDIT_MANUAL_FAIL';
export const CHAPTERS_INIT = 'CHAPTERS_INIT';
export const DELETE_CHAPTER = 'DELETE_CHAPTER';
export const DELETE_CHAPTER_SUCCESS = 'DELETE_CHAPTER_SUCCESS';
export const DELETE_CHAPTER_FAIL = 'DELETE_CHAPTER_FAIL';
export const DELETE_MANUAL = 'DELETE_MANUAL';
export const DELETE_MANUAL_SUCCESS = 'DELETE_MANUAL_SUCCESS';
export const DELETE_MANUAL_FAIL = 'DELETE_MANUAL_FAIL';
export const GET_LIST_CHAPTERS = 'GET_LIST_CHAPTERS';
export const GET_LIST_CHAPTERS_SUCCESS = 'GET_LIST_CHAPTERS_SUCCESS';
export const GET_LIST_CHAPTERS_FAIL = 'GET_LIST_CHAPTERS_FAIL';

export const GET_USER_MANUAL = 'GET_USER_MANUAL';
export const GET_USER_MANUAL_SUCCESS = 'GET_USER_MANUAL_SUCCESS';
export const GET_USER_MANUAL_FAIL = 'GET_USER_MANUAL_FAIL';
export const MOVE_CHAPTER = 'MOVE_CHAPTER';
export const MOVE_CHAPTER_SUCCESS = 'MOVE_CHAPTER_SUCCESS';
export const MOVE_CHAPTER_FAIL = 'MOVE_CHAPTER_FAIL';
export const MOVE_MANUAL = 'MOVE_MANUAL';
export const MOVE_MANUAL_SUCCESS = 'MOVE_MANUAL_SUCCESS';
export const MOVE_MANUAL_FAIL = 'MOVE_MANUAL_FAIL';

export const SET_USER_MANUAL = 'SET_USER_MANUAL';
export const SET_USER_MANUAL_SUCCESS = 'SET_USER_MANUAL_SUCCESS';
export const SET_USER_MANUAL_FAIL = 'SET_USER_MANUAL_FAIL';

export const VIDEO_VIEWER_OPEN = 'VIDEO_VIEWER_OPEN';
export const VIDEO_VIEWER_CLOSE = 'VIDEO_VIEWER_CLOSE';

export const VIDEO_VIEWER_BY_STOCK_OPEN = 'VIDEO_VIEWER_BY_STOCK_OPEN';
export const VIDEO_VIEWER_BY_STOCK_OPEN_SUCCESS = 'VIDEO_VIEWER_BY_STOCK_OPEN_SUCCESS';
export const VIDEO_VIEWER_BY_STOCK_OPEN_FAIL = 'VIDEO_VIEWER_BY_STOCK_OPEN_FAIL';
